import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NavBar } from "./sidebarStyle";
import linkedinImg from "../../assets/icons/linkedin.svg";
import githubImg from "../../assets/icons/github.svg";
import twitterImg from "../../assets/icons/twitter.svg";
import { AstroBtn, Bubble } from "../../utils/customStyles";

const Sidebar = () => {
  const location = useLocation();

  const pathName = (route) => {
    if (route === location.pathname) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <NavBar>
      <div className="logo-div">
        <Link to="/">
          <h1>&lt;A&#47;&gt;</h1>
        </Link>
      </div>
      <ul className="nav-list">
        <li className="nav-item">
          <NavLink
            exact="true"
            activeclassname="active"
            to="/about"
            style={{
              color: pathName("/about") ? "#3bcfe3" : "#C2C2C2",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            About
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            exact="true"
            activeclassname="active"
            to="/skill"
            style={{
              color: pathName("/skill") ? "#3bcfe3" : "#C2C2C2",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            Skills
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            exact="true"
            to="/portfolio"
            style={{
              color: pathName("/portfolio") ? "#3bcfe3" : "#C2C2C2",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            Portfolio
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink exact="true" activeclassname="active" to="/blog" style={{
              color: pathName("/blog") ? "#3bcfe3" : "#C2C2C2",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}>
            Blog
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            exact="true"
            activeclassname="active"
            to="/contact"
            style={{
              color: pathName("/contact") ? "#3bcfe3" : "#C2C2C2",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            Contact
          </NavLink>
        </li>
      </ul>

      <ul className="contact-icons">
        <li className="icon-item">
          <a
            href="https://www.linkedin.com/in/emmanuel-agba" target='blank'
            className="icon-link"
          >
            <img src={linkedinImg} alt="LinkedIn" />
          </a>
        </li>
        <li className="icon-item">
          <a href="https://github.com/tracemycodes" target='blank' className="icon-link">
            <img src={githubImg} alt="github" />
          </a>
        </li>
        <li className="icon-item">
          <a href="https://twitter.com/trace_it" target='blank' className="icon-link">
            <img src={twitterImg} alt="twitter" />
          </a>
        </li>
      </ul>
      <AstroBtn>
        <a
          href="https://drive.google.com/file/d/1rOWVzjDYBL888n1iS0NZ8PEWkcEXww4U/view?usp=sharing"
          target="blank"
        >
          Resume
        </a>
        <Bubble count={1}></Bubble>
        <Bubble count={2}></Bubble>
        <Bubble count={3}></Bubble>
        <Bubble count={4}></Bubble>
      </AstroBtn>
    </NavBar>
  );
};

export default Sidebar;
